<template>
    <v-dialog
        transition="dialog-bottom-transition"
        max-width="1600"
        v-model="isOpenViewDialog"
        eager
        persistent
        scrollable
    >
        <v-card>
            <v-toolbar flat class="d-flex justify-center">
                <h2 :class="`text-overline ${getStatusColor}--text`">
                    Estado de la oferta: {{ statusCapitalized }}
                </h2>
                <v-icon size="20" :color="getStatusColor" class="ml-2">{{ getStatusIcon }}</v-icon>
            </v-toolbar>
            <v-btn
                color="success"
                text
                v-if="canTransact"
                @click="transact()"
            >
                Marcar Como Tramitada
                <v-icon>mdi-cash-register</v-icon>
            </v-btn>
            <v-btn
                color="primary"
                text
                v-else-if="offer && offer.processed"
                disabled
            >
                Oferta Tramitada
                <v-icon>mdi-cash-register</v-icon>
            </v-btn>
            <v-btn
                color="primary"
                text
                v-else
                disabled
            >
                Solo se pueden tramitar ofertas en estado Vendido
                <v-icon>mdi-cash-register</v-icon>
            </v-btn>

            <div class="pa-3" style="overflow-y: scroll">
                <LoadingSkeleton
                    v-if="PDFView.isLoadingHtmlOffer && !isOfertaAntigua(offer)"
                    style="width: 100%; height: 100%"
                />
                <div v-if="error" style="position: absolute; top: 50%">
                    <h1 class="display-3 red--text">El recurso solicitado no se encuentra disponible</h1>
                </div>
                <iframe
                    frameBorder="0"
                    v-show="
                        !PDFView.isLoadingHtmlOffer && !isOfertaAntigua(offer)
                    "
                    id="frameOferta"
                    ref="frameOferta"
                    style="width: 100%; overflow-y: scroll; height: 700px"
                ></iframe>
                <div
                    v-if="
                        offer &&
                        isOfertaAntigua(offer) &&
                        offer.paquetes.length > 0
                    "
                >
                    <div
                        v-for="(paquete, index) in offer.paquetes"
                        :key="index"
                    >
                        <h3
                            class="
                                pt-md-3
                                d-flex
                                justify-center
                                font-weight-light
                                grey--text
                            "
                        >
                            {{ paquete.unidadVentaDeprecated }}
                        </h3>
                        <v-divider class="mx-md-16"></v-divider>
                    </div>
                </div>
                <div v-else-if="offer && isOfertaAntigua(offer)">
                    <h2
                        class="
                            pt-md-3
                            d-flex
                            justify-center
                            font-weight-thin
                            grey--text
                        "
                    >
                        Venta No registrada
                    </h2>
                </div>
            </div>
            <v-progress-linear
                v-if="isLoadingDownloadPDF"
                color="#F50057"
                indeterminate
                rounded
                height="6"
            ></v-progress-linear>
            <v-card-actions :class="$vuetify.breakpoint.xs ? 'd-flex flex-column' : 'd-flex justify-end'">
                <v-btn
                    v-if="offer && !isOfertaAntigua(offer)"
                    color="primary"
                    outlined
                    @click="sendOfferAsync(offer.id)"
                    :disabled="!offer.atencion.cliente.email"
                    style="border: 0px !important"
                >
                    Enviar a {{ offer.atencion.cliente.email }}
                    <v-icon class="ml-2">mdi-email</v-icon>
                </v-btn>
                <div class="d-flex">
                    <v-btn
                        v-if="
                            !isOfertaAntigua(offer) && !PDFView.isLoadingHtmlOffer
                        "
                        color="orange"
                        outlined
                        @click="downloadOfferPDF(offer)"
                        style="border: 0px !important"
                    >
                        Descargar
                        <v-icon class="ml-2">mdi-download</v-icon>
                    </v-btn>
                    <v-btn color="red" text @click="closeDialog">Cerrar</v-btn>
                </div>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import LoadingSkeleton from '../ComercialTeletrabajo/DetailedView/LoadingSkeleton.vue';

export default {
    name: 'PDFView',
    data: () => ({
        STATUS: {
            VENDIDO: { color: 'green', icon: 'mdi-check-circle' },
            RECHAZADO: { color: 'red', icon: 'mdi-close-circle' },
            OFERTADO: { color: 'orange', icon: 'mdi-tag' },
            CONTRATADO: { color: 'blue', icon: 'mdi-handshake' },
            TRAMITADO: { color: 'purple', icon: 'mdi-cash-register' },
        },
    }),
    components: {
        LoadingSkeleton,
    },
    props: {
        offer: null,
        parentRenderMutation: null,
        parentDownloadMutation: null,
        error: false,
    },
    methods: {
        downloadOfferPDF(offer) {
            if(offer?.id){
                this.$store.commit('util/isLoadingDownloadPDF', true);
                this.fetchPDFOffer(offer.id).then(() => {
                    this.$store.commit('util/isLoadingDownloadPDF', false);
                });
            } else if (this.parentDownloadMutation){
                this.$store.commit('util/isLoadingDownloadPDF', true);
                this.$store.dispatch(this.parentDownloadMutation).then(() => {
                    this.$store.commit('util/isLoadingDownloadPDF', false);
                });            
            } else {
                window.frames["frameOferta"].focus();
                window.frames["frameOferta"].contentWindow.print();
            }
        },
        generateHtmlOffer() {
            this.$store.commit('util/PDFView', {
                isLoadingHtmlOffer: true,
                isOpenViewDialog: true,
                ofertaHtml: '',
            });

            if (!this.isOfertaAntigua(this.offer) && this.offer?.id) {
                setTimeout(
                    () =>
                        this.fetchHtmlOffer(this.offer.id).then(() => {
                            this.$store.commit('util/isLoadingPDFView', false);
                        }),
                    100
                );
            } else if (this.parentRenderMutation){
                setTimeout(() => {
                    this.$store.dispatch(this.parentRenderMutation).then(() => {
                        this.$store.commit('util/isLoadingPDFView', false);
                    });
                }, 100);
            } else {
                this.$store.commit('util/PDFView', {
                    isLoadingHtmlOffer: false,
                    isOpenViewDialog: true,
                    ofertaHtml: '',
                });
                this.error = true;
            }
        },
        isOfertaAntigua(oferta) {
            if (oferta) {
                return (
                    !oferta.paquetes.length ||
                    oferta.paquetes.some(
                        ({ unidadVentaDeprecated }) =>
                            unidadVentaDeprecated != null
                    )
                );
            }
        },
        closeDialog() {
            this.$store.commit('util/PDFView', {
                isLoadingHtmlOffer: false,
                isOpenViewDialog: false,
                ofertaHtml: '',
            });
            this.$refs.frameOferta.contentDocument.close();
        },
        sendOfferAsync(offerId) {
            this.$store.dispatch('util/dispatchAsyncTask', {
                taskName: 'send_client_offer_async',
                taskParams: {
                    offer_id: offerId,
                },
            });
            this.$store.dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: 'La oferta se está enviando, el cliente la recibirá en breve',
                timeout: 2000,
            }, { root: true })
        },
        async transact() {
            await this.updateOffer({
                id: this.offer.id,
                processed: true
            });
            this.offer.processed = true;
        },
        ...mapActions({
            fetchHtmlOffer: 'util/fetchHtmlOffer',
            fetchPDFOffer: 'util/fetchPDFOffer',
        }),
		...mapActions({
			updateOffer: 'areaPersonal/calculadora/updateOffer',
		}),
    },
    computed: {
        statusCapitalized() {
            return this.offer?.estado.charAt(0).toUpperCase() + this.offer?.estado.slice(1).toLowerCase();
        },
        getStatusColor() {
            if (this.offer?.processed) {
                return this.STATUS['TRAMITADO'].color;
            }
            return this.STATUS[this.offer?.estado]?.color;
        },
        getStatusIcon() {
            if (this.offer?.processed) {
                return this.STATUS['TRAMITADO'].icon;
            }
            return this.STATUS[this.offer?.estado]?.icon;
        },
        canTransact() {
            return (this.hasAdminPermission || this.hasManagerPermission || this.hasSuperAdminPermission) && this.offer?.estado === 'VENDIDO' && !this.offer?.processed;
        },
        ...mapState('util', {
            PDFView: (state) => state.PDFView,
            ofertaHtml: (state) => state.PDFView.ofertaHtml,
            isOpenViewDialog: (state) => state.PDFView.isOpenViewDialog,
            isLoadingDownloadPDF: (state) => state.isLoadingDownloadPDF,
        }),
		...mapGetters('login', {
			hasAdminPermission: 'hasAdminPermission',
			hasManagerPermission: 'hasManagerPermission',
            hasSuperAdminPermission: 'hasSuperAdminPermission',
		}),
    },
    watch: {
        ofertaHtml() {
            this.$refs.frameOferta.contentDocument.write('');
            this.$refs.frameOferta.contentDocument.write(
                this.PDFView.ofertaHtml
            );
        },
        isOpenViewDialog(val) {
            if (val) {
                this.generateHtmlOffer();
            }
        },
    },
    // mounted() {
    //     this.generateHtmlOffer();
    // },
    // beforeCreate() {
    // },
};
</script>